import React, { MouseEvent } from 'react';

import AuthService from '../../shared/services/AuthService';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Link from '@mui/material/Link';
import MessageBox from './MessageBox';
import RequestVerificationEmailFail from './RequestVerificationEmailFail';
import RequestVerificationEmailSuccess from './RequestVerificationEmailSuccess';
import Typography from '@mui/material/Typography';
import useRequestVerificationEmail from '../hooks/useRequestVerificationEmail';

interface RegistrationSuccessProps {
  email: string;
  verificationEmailSent: boolean;
  successMessage?: string;
}

const RegistrationSuccess = (props: RegistrationSuccessProps) => {
  const { email } = props;
  const tenant = AuthService.Tenant;
  const { requestVerificationEmail, loading, error, success } =
    useRequestVerificationEmail(tenant, email);

  if (loading) {
    return (
      <Grid container justifyContent="center" direction="column" spacing={2}>
        <Grid>
          <Typography variant="h6" color="primary" align="center">
            Sending verification email...
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (error || success?.requestVerificationEmail === false) {
    return <RequestVerificationEmailFail />;
  }

  if (success?.requestVerificationEmail === true) {
    return <RequestVerificationEmailSuccess email={email} />;
  }

  return props.verificationEmailSent ? (
    <MessageBox
      header="Success!"
      message="We've sent a confirmation email to:"
      additionalMessage={props.email}
      secondaryHeader="Not received an email?"
      secondaryMessage={
        <div>
          Check your spam folder or have us
          <Link
            className="smaller-font"
            href="#"
            onClick={(e: MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();
              requestVerificationEmail();
            }}
          >
            <br />
            send a new confirmation email
          </Link>
          .
        </div>
      }
    />
  ) : (
    <MessageBox
      header="Success!"
      message={
        props.successMessage || 'Your account registration was successful.'
      }
      secondaryMessage={
        <Button
          color="secondary"
          style={{ width: '100%' }}
          onClick={() => (window.location.href = '/')}
        >
          Login
        </Button>
      }
    />
  );
};

export default RegistrationSuccess;
